var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-tag',{style:({color:'#FFF'}),attrs:{"type":"info","color":_vm.value.color,"closable":""},on:{"close":function($event){return _vm.$emit('delete',_vm.value)}}},[_vm._v(_vm._s(_vm.value.name))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }